// extracted by css-extract-rspack-plugin
module.exports =  {"redDescription":"AllIncome__redDescription--YTbww","spouse":"AllIncome__spouse--OZFtx Form__box--BfBHj","primaryPanelHeader":"AllIncome__primaryPanelHeader--QEbQj"};